// Подът на схемата е милиметрова хартия: ситно каре на 20 см и едро на всеки
// метър. Карето е част от пода — расте и се смалява със зуума и тръгва от
// горния ляв ъгъл на региона. Размерът и отместването се знаят чак по време
// на изпълнение (мащабът), затова са inline style (изключение (1) от правило 3);
// линиите са токените `schema-grid` / `schema-grid-major` — неутрални и едва
// видими върху `surface`, както плочките в макета на началния екран.

import type { CSSProperties } from "react";

/** Ситното каре — 20 см; едрото е на GRID_SUBDIVISIONS ситни (1 м). */
const GRID_MINOR_UNITS = 20;
const GRID_SUBDIVISIONS = 5;
// Под толкова пиксела ситното каре се слива в сиво петно — остава само едрото.
const MIN_MINOR_PX = 7;

/** Четирите слоя на хартията: едрите линии (→, ↓) над ситните (→, ↓). */
export const FLOOR_GRID_CLASS =
  "bg-surface bg-[linear-gradient(to_right,var(--color-schema-grid-major)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-schema-grid-major)_1px,transparent_1px),linear-gradient(to_right,var(--color-schema-grid)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-schema-grid)_1px,transparent_1px)]";

/**
 * Размерът и началото на карето при мащаб `scale` (пиксели за логическа
 * единица); `origin` е горният ляв ъгъл на региона спрямо елемента с фона.
 * Стъпката е цяло число пиксели — линиите остават остри при всеки зуум.
 */
export const floorGridStyle = (
  scale: number,
  origin: { left: number; top: number } = { left: 0, top: 0 },
): CSSProperties => {
  const minor = Math.max(1, Math.round(GRID_MINOR_UNITS * scale));
  const major = minor * GRID_SUBDIVISIONS;
  const majorSize = `${major}px ${major}px`;
  // Нулев размер = слоят не се рисува.
  const minorSize = minor >= MIN_MINOR_PX ? `${minor}px ${minor}px` : "0 0";
  return {
    backgroundSize: `${majorSize}, ${majorSize}, ${minorSize}, ${minorSize}`,
    backgroundPosition: `${Math.round(origin.left)}px ${Math.round(origin.top)}px`,
  };
};
